import { Centrifuge as CentrifugeImpl, type Options } from 'centrifuge'

import { env } from '@/shared/config'

import { Centrifuge as CentrifugeMock } from './mock'
import type { ICentrifuge } from './types'

export type { ConnectedContext, DisconnectedContext } from 'centrifuge'

export * from './types'

export const newCentrifuge: (endpoint: string, opts?: Partial<Options>) => ICentrifuge = (() => {
    if (env.MOCK_API_ENABLE) {
        return (_endpoint, _opts) => new CentrifugeMock()
    }
    return (endpoint, opts) => new CentrifugeImpl(endpoint, opts)
})()
